import { Pipe, PipeTransform } from '@angular/core';
import * as moment_ from 'moment';

@Pipe({
    name: 'formatDate'
})

export class DatePipe implements PipeTransform {
    moment = moment_;
    transform(date: any, format: any): any {
        if (date) {
            return this.moment.utc(date).format(format);
        } else {
            return '';
        }
    }
}